package com.trevorwiebe.timesheet.core.domain.model

import kotlinx.datetime.LocalDate

data class DatabaseUserModel(
    val id: String,
    val role: UserRole,
    val email: String,
    val fullTime: Boolean,
    val hireDate: LocalDate,
    val name: String,
    val nickname: String,
    val organizationId: String,
    val ptoBalance: Int,
    val holidayTime: Boolean,
    val payEntryId: String,
    val deleted: Boolean,
    val ownerOperatorId: String? = null
) {
    val ptoBalanceDays = ptoBalance.toDouble() / 8.0
    val displayName: String = nickname.ifBlank { name }
}
